import DataFrame from "../../components/DataFrame/DataFrame";
import Logo from "../../components/Logo";

import { useEffect, useState } from "react";
import OTPLogin from "./OTPLogin";
import ChildCode from "./ChildCode";
import { useLocation } from "react-router";

const doesRedirectCookieExists =
  document.referrer == "https://parent.heroicgameday.com/dashboard/";

export default function Login() {
  const [loginType, setloginType] = useState<"child_code" | "otp">(
    "child_code"
  );
  const [hideChildCode, setHideChildCode] = useState(false);
  const { state } = useLocation();

  useEffect(() => {
    if (doesRedirectCookieExists || state?.hideCodeBtn) {
      setloginType("otp");
      setHideChildCode(true);
    }
  }, [state?.hideCodeBtn]);

  return (
    <div className="flex flex-col h-full justify-center items-center">
      <div className="absolute left-6 top-6 ">
        <Logo />
      </div>
      <DataFrame>
        {loginType == "child_code" && (
          <ChildCode
            hideChildCode={hideChildCode}
            setloginType={setloginType}
            loginType={loginType}
          />
        )}
        {loginType == "otp" && (
          <OTPLogin
            setloginType={setloginType}
            loginType={loginType}
            hideChildCode={hideChildCode}
          />
        )}
      </DataFrame>
    </div>
  );
}
